import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { jsx as _jsx } from "react/jsx-runtime";
const MissingHipaaAccess = () => {
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    justifyContent: "space-between",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "start",
      justifyContent: "center",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        illustration: "keys",
        illustrationProps: {
          width: 150
        },
        title: /*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "aiAddonCopilotPreview.components.copilotV2.hipaaTitle"
          })
        })
      })
    })
  });
};
export default MissingHipaaAccess;